<template>
  <div class="base-menu" data-slot="default">
    <template v-for="menu in storeMenus" :key="menu.id">
      <template v-if="menu.position === menuPosition">
        <div v-for="item in menu.children" :key="item.id" class="base-menu-item-wrapper">


          <div class="dropdown " v-if="item.children.length !== 0">
            <a href="javascript:void(0)"
               class=" dropdown-toggle base-menu-item text-dark text-decoration-none"
               data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <m-menu-icon-manager :item="item"/>
              <span class="base-menu-item-text">{{ item.name }}</span>
            </a>
            <div class="dropdown-menu">
              <m-a class="dropdown-item text-dark text-decoration-none" :href="child.url" v-for="child in item.children"
                   :key="child.id">
                <m-menu-icon-manager :item="child"/>
                <span class="base-menu-item-text">{{ child.name }}</span>
              </m-a>
            </div>
          </div>

          <m-base-menu-item class="text-dark" v-else :item-icon="item.icon_class" :item-link="item.url" :item-text="item.name"/>

        </div>
      </template>
    </template>
    <slot></slot>
  </div>
</template>

<script>
import {MenuProps} from './MenuProps'
import {mapGetters} from "vuex";
import mA from '../Tags/A'
import mIcon from '../Icons/Icon'
import mBaseMenuItem from './BaseMenuItem'
import mMenuIconManager from "./MenuIconManager.vue";

export default {
  name: "BaseMenu",
  components: {mMenuIconManager, mA, mIcon, mBaseMenuItem,},
  props: {
    ...MenuProps
  },
  computed: {
    ...mapGetters({
      storeMenus: "Menu/getAllMenus",
      isAuth: "User/isAuthenticated",
      orderCount: 'ShoppingCart/getSidebarBasketData',
    }),
  },
}
</script>

<style scoped>
.dropdown-toggle::after{

  margin:0 5px;

}
</style>